import { Directive } from '@angular/core';
import { OpportunityFacade } from '../+state/opportunity-state-base.component';

@Directive()
export abstract class OpportunityBaseComponent extends OpportunityFacade {
  public text = 'Opportunity';

  constructor() {
    super();
  }
}
